var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { createSlice } from "@reduxjs/toolkit";
import { getAccessToken, getUserInfo, logIn, logOut, setTokenScopeToProject, } from "../../api/account";
import { getPlatformDomain } from "./appSlice";
var initialState = {
    token: null,
    info: {},
    userToken: null,
    scopedTokenPresent: false,
};
var slice = createSlice({
    name: "user",
    initialState: initialState,
    reducers: {
        getUserInfoSuccess: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { info: payload }));
        },
        getUserInfoFailed: function (state) { return (__assign(__assign({}, state), { info: {} })); },
        getTokenSuccess: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { token: payload }));
        },
        getTokenFailed: function (state) { return (__assign(__assign({}, state), { token: null })); },
        logOutSuccess: function (state) { return (__assign(__assign({}, state), { token: null, info: {} })); },
        setUserToken: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { userToken: payload, info: {} }));
        },
        setScopedTokenPresent: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { scopedTokenPresent: payload }));
        },
    },
});
export var getTokenSuccess = (_a = slice.actions, _a.getTokenSuccess), getTokenFailed = _a.getTokenFailed, getUserInfoSuccess = _a.getUserInfoSuccess, getUserInfoFailed = _a.getUserInfoFailed, logOutSuccess = _a.logOutSuccess, setUserToken = _a.setUserToken, setScopedTokenPresent = _a.setScopedTokenPresent;
export var isUserAuthenticated = function (state) {
    return state.user.userToken !== null;
};
export var initLogIn = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var haWeb, domain;
    return __generator(this, function (_a) {
        try {
            haWeb = getState().app.platform.config.haWeb;
            domain = getPlatformDomain(getState());
            return [2 /*return*/, logIn(domain, haWeb)];
        }
        catch (err) {
            console.log(err);
        }
        return [2 /*return*/];
    });
}); }; };
export var initLogOut = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var hereAccountApiBase, domain, token, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                hereAccountApiBase = getState().app.platform.config.hereAccountApiBase;
                domain = getPlatformDomain(getState());
                token = getState().user.userToken;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, logOut(domain, hereAccountApiBase, token)];
            case 2:
                _a.sent();
                dispatch(logOutSuccess());
                dispatch(initLogIn());
                return [3 /*break*/, 4];
            case 3:
                e_1 = _a.sent();
                console.error(e_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
/**
 * This method is used to fetch userToken and ProjectScoped Token
 * Platform APIs need userToken and distribution APIs need project scoped token to access catalog and data associated to it
 * @returns
 */
export var fetchAccessToken = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var token, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getAccessToken(getPlatformDomain(getState()))];
            case 1:
                token = _a.sent();
                if (token) {
                    // userToken is needed to get userInfo
                    dispatch(setUserToken(token));
                    //on each login, there is new token hence assign project scope to token
                    //commenting here since it needs to be called post configuration and project is setup
                    dispatch(setTokenScopeToProject(token));
                }
                return [3 /*break*/, 3];
            case 2:
                err_1 = _a.sent();
                dispatch(getTokenFailed());
                // redirect to login
                dispatch(initLogIn());
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var fetchUserInfo = function (token) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var accessToken, hereAccountApiBase, info, userInitials, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                accessToken = token || getState().user.userToken;
                hereAccountApiBase = getState().app.platform.config.hereAccountApiBase;
                return [4 /*yield*/, getUserInfo(hereAccountApiBase.split("https://").pop(), accessToken)];
            case 1:
                info = _a.sent();
                if (info) {
                    userInitials = "".concat(info === null || info === void 0 ? void 0 : info.given_name.charAt(0).toUpperCase(), " ").concat(info === null || info === void 0 ? void 0 : info.family_name.charAt(0).toUpperCase());
                    dispatch(getUserInfoSuccess(__assign(__assign({}, info), { userInitials: userInitials })));
                }
                return [3 /*break*/, 3];
            case 2:
                err_2 = _a.sent();
                dispatch(getUserInfoFailed());
                dispatch(initLogIn());
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export default slice.reducer;
